"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_FORMATTED_BALANCE = exports.UPDATE_BALANCE_FORCE = exports.UPDATE_BALANCE_BET_FEATURE_BUY = exports.UPDATE_BALANCE_BET = exports.UPDATE_BALANCE = void 0;
var UPDATE_BALANCE = exports.UPDATE_BALANCE = "UPDATE_BALANCE";
var UPDATE_FORMATTED_BALANCE = exports.UPDATE_FORMATTED_BALANCE = "UPDATE_FORMATTED_BALANCE";

/**
 * USed to change the balance after a start round, basically balance-bet to give instant feedback on balance
 */
var UPDATE_BALANCE_BET = exports.UPDATE_BALANCE_BET = "UPDATE_BALANCE_BET";
var UPDATE_BALANCE_BET_FEATURE_BUY = exports.UPDATE_BALANCE_BET_FEATURE_BUY = "UPDATE_BALANCE_BET_FEATURE_BUY";
var UPDATE_BALANCE_FORCE = exports.UPDATE_BALANCE_FORCE = "UPDATE_BALANCE_FORCE";
//Actions
//# sourceMappingURL=types.js.map